import { Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  HeadTableCell,
  RowTableCell,
  CustomButton,
  GeneralTableBox,
  PaginationTable,
  DialogBody,
  SearchBar,
  ActionIconButton,
} from '../../../common/components';
import PostAddIcon from '@mui/icons-material/PostAdd';

import ScoreCoefficientDialog from '../dialogs/ScoreCoefficientDialog';
import { formatDate } from '../../utils/plansUtils';
import { usePaginatedFilter } from '../../../common/hooks/usePaginatedFilter';

const ITEMS_PER_PAGE = 5;

const filterScoreCoefficients = (collection = [], term = '') => {
  if (!term?.trim()) return collection;
  const normalized = term.toLowerCase().trim();

  return collection.filter((coefficient) => {
    const valueMatch = coefficient.value?.toString().toLowerCase().includes(normalized);
    const startMatch = coefficient.start_date?.toLowerCase().includes(normalized);
    const endMatch = coefficient.due_date?.toLowerCase().includes(normalized);
    return valueMatch || startMatch || endMatch;
  });
};

const ScoreCoefficientsTab = ({
  data,
  selectedItem,
  dialogOpen,
  editMode,
  handleAdd,
  handleEdit,
  handleDelete,
  handleClose,
  handleSave,
}) => {
  const {
    data: paginatedCoefficients,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
  } = usePaginatedFilter({
    data,
    itemsPerPage: ITEMS_PER_PAGE,
    filterFn: filterScoreCoefficients,
  });

  return (
    <DialogBody sx={{ p: 2, minHeight: '65vh' }}>
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <CustomButton variant="contained" onClick={handleAdd}>
            <PostAddIcon sx={{ mr: 1 }} />
            Agregar
          </CustomButton>
          <SearchBar onSearch={handleSearch} />
        </Box>

        <GeneralTableBox>
          <Table>
            <TableHead>
              <TableRow>
                <HeadTableCell>Valor</HeadTableCell>
                <HeadTableCell>Fecha Inicio</HeadTableCell>
                <HeadTableCell>Fecha Fin</HeadTableCell>
                <HeadTableCell>Acciones</HeadTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedCoefficients.map((coefficient, index) => (
                <TableRow key={coefficient.id || index}>
                  <RowTableCell>{coefficient.value}</RowTableCell>
                  <RowTableCell>{formatDate(coefficient.start_date)}</RowTableCell>
                  <RowTableCell>{formatDate(coefficient.due_date)}</RowTableCell>
                  <RowTableCell>
                    <ActionIconButton variant="edit" onClick={() => handleEdit(coefficient)} />
                    <ActionIconButton
                      variant="delete"
                      onClick={() => handleDelete(coefficient.uuid)}
                    />
                  </RowTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {totalCount > rowsPerPage && (
            <PaginationTable
              totalPages={totalPages}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              totalCount={totalCount}
            />
          )}
        </GeneralTableBox>
      </Box>

      <ScoreCoefficientDialog
        open={dialogOpen}
        onClose={handleClose}
        onSave={handleSave}
        selectedItem={selectedItem}
        editMode={editMode}
      />
    </DialogBody>
  );
};

export default ScoreCoefficientsTab;
